export default __webpack_public_path__ + "media/titles/title_6_locale_en-8fd0b6c6.png";